/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Done_TodayInputs */

const bn_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আজ হয়ে গেছে`)
};

const de_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Heute erledigt`)
};

const el_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Έγινε σήμερα`)
};

const en_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Done today`)
};

const es_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hecho hoy`)
};

const fr_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminé aujourd’hui`)
};

const hi_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आज हो गया`)
};

const hu_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ma kész`)
};

const id_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Selesai hari ini`)
};

const it_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fatto oggi`)
};

const ja_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今日完了`)
};

const ko_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오늘 완료`)
};

const nl_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vandaag gedaan`)
};

const pl_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrobione dzisiaj`)
};

const pt_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Feito hoje`)
};

const ru_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово сегодня`)
};

const sv_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klart idag`)
};

const tr_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bugün bitti`)
};

const uk_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Готово сьогодні`)
};

const vi_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoàn thành hôm nay`)
};

const zh_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天完成`)
};

const zh_hant_game_done_today = /** @type {(inputs: Game_Done_TodayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`今天完成`)
};

/**
* | output |
* | --- |
* | "Done today" |
*
* @param {Game_Done_TodayInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_done_today = /** @type {((inputs?: Game_Done_TodayInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Done_TodayInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_done_today(inputs)
	if (locale === "de") return de_game_done_today(inputs)
	if (locale === "el") return el_game_done_today(inputs)
	if (locale === "en") return en_game_done_today(inputs)
	if (locale === "es") return es_game_done_today(inputs)
	if (locale === "fr") return fr_game_done_today(inputs)
	if (locale === "hi") return hi_game_done_today(inputs)
	if (locale === "hu") return hu_game_done_today(inputs)
	if (locale === "id") return id_game_done_today(inputs)
	if (locale === "it") return it_game_done_today(inputs)
	if (locale === "ja") return ja_game_done_today(inputs)
	if (locale === "ko") return ko_game_done_today(inputs)
	if (locale === "nl") return nl_game_done_today(inputs)
	if (locale === "pl") return pl_game_done_today(inputs)
	if (locale === "pt") return pt_game_done_today(inputs)
	if (locale === "ru") return ru_game_done_today(inputs)
	if (locale === "sv") return sv_game_done_today(inputs)
	if (locale === "tr") return tr_game_done_today(inputs)
	if (locale === "uk") return uk_game_done_today(inputs)
	if (locale === "vi") return vi_game_done_today(inputs)
	if (locale === "zh") return zh_game_done_today(inputs)
	return zh_hant_game_done_today(inputs)
});